import { IGameIdentity } from '@avid/common';

import { CLIENT_ID } from 'constants/settings';

export const getGameIdentity = (gameCode: string): IGameIdentity => ({
  clientId: CLIENT_ID,
  gameCode,
});
